import React, { useCallback, useRef, useState } from "react";

import type { IAfterGuiAttachedParams } from "ag-grid-community";
import type { CustomFilterDisplayProps } from "ag-grid-react";
import { useGridFilterDisplay } from "ag-grid-react";
import { DateRangePickerModal } from "components";
import { List } from "antd";
import { DateUtils } from "utils/dateutils";

import "./custom-date-filter.css";

export function CustomDateFilterComponent({
  onModelChange,
  colDef,
  context
}: CustomFilterDisplayProps) {
  const refInput = useRef<HTMLInputElement>(null);
  const [customDateRange, setCustomDateRange] = useState<any>({});
  const [isCustomDatePickerOpen, setIsCustomDatePickerOpen] =
    useState<boolean>(false);
  const dueDateFilters = context?.isProjectList
    ? ["Custom"]
    : ["Past today", "Today", "Next 3 days", "Next 2 weeks", "Custom"];

  const afterGuiAttached = useCallback((params?: IAfterGuiAttachedParams) => {
    if (!params || !params.suppressFocus) {
      // Focus the input element for keyboard navigation.
      // Can't do this in an effect,
      // as the component is not recreated when hidden and then shown again

      window.setTimeout(() => {
        refInput.current?.focus();
      });
    }
  }, []);

  // register filter handlers with the grid
  useGridFilterDisplay({
    afterGuiAttached
  });

  const onCustomDateFilterChanged = () => {
    if (customDateRange) {
      onModelChange({
        values: ["CustomDateRange"],
        filterType: "date",
        type: "inRange",
        dateFrom: DateUtils.format(customDateRange[0]),
        dateTo: DateUtils.format(customDateRange[1])
      });
    } else {
      onModelChange({ values: [""], filterType: "set" });
    }
  };

  return (
    <>
      <div className="custom-date-filters">
        <List
          className="filter-list"
          dataSource={dueDateFilters}
          renderItem={(item) => (
            <List.Item
              onClick={() => {
                if (item === "Custom") {
                  setIsCustomDatePickerOpen(true);
                  return;
                }
                onModelChange({ values: [item], filterType: "set" });
              }}
            >
              {item}
            </List.Item>
          )}
        />
      </div>
      <DateRangePickerModal
        title={colDef.headerName}
        isOpen={isCustomDatePickerOpen}
        setIsOpen={setIsCustomDatePickerOpen}
        setCustomDateRange={setCustomDateRange}
        onOkClick={onCustomDateFilterChanged}
      />
    </>
  );
}
